export interface SiteContext {
    sessionKey: string,
    defaultCurrencyCode: any,
    pointMultiplier: number,
    name: string,
    enableRedeemPointFlow: boolean,
    enableEarnPointFlow: boolean,
    enableGuestFlow: boolean,
    channelId: string;
    accountId: string;
    user: string;
    defaultRedirectionUrl: string;
    externalHomePage: string;
    authMechanism: string;
    hideTotalPrice: boolean;
    enablePromotion: boolean;
    enableAmenitiesOnCheckout: boolean;
    enableMSP: boolean;
    displaySetting: DisplaySetting | any;
}

export interface DisplaySetting {
    googleAnalyticsCode: string;
    displayPerNightPrice: boolean;
    header: DisplayHeader;
    footer: DisplayFooter;
    address: string;
    phone: string;
    fax: string;
    email: string;
    styles: {
        primaryColor: string;
        headerBackgroundColor: string;
    },
    metaTagas: {
        name: string;
        content: string;
    }[]
}

export interface DisplayHeader {
    logo: string;
    navLinks: DisplayLink[];
    allowCurrencies: string[];
    navText: string
}


export interface DisplayFooter {
    facebookHref: string;
    youtubeHref: string;
    instagramHref: string;
    linkedInHref: string;
    twitterHref: string;
    tiktokHref: string;
    links: DisplayLink[];
    copyright: string;
}

export interface DisplayLink {
    text: string;
    order: number;
    href: string;
}

export interface Currency {
    code: string,
    symbol: string
}

export interface ApiResponse {
    status: ApiStatus
}

export class ApiStatus {
    static Success = "success"
    static Failure = "failure"
}